import { browser } from '$app/environment';
import { activeLocale, resolveDisplayLocale } from '$lib/i18n';
import { app } from '$lib/stores/app/store';
import { Page } from '$lib/utils/page';
import { get } from 'svelte/store';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';
import { l10n, preload } from './_i18n';

export const prerender = true;

/**
 * Loads the page data
 * @param {import('./$types').PageLoadEvent} event - SvelteKit load event.
 * @returns {Promise<{metadata: import('$lib/utils/page').PageMetadata, page?: Page}>} The page data.
 */
export async function load(event) {
	if (browser) {
		event.depends('app:locale');
		const locale = resolveDisplayLocale();
		activeLocale.set(locale);
		await preload(locale, get(app).meta.viewerCountry);
	}

	const localize = get(l10n);
	const metaDescription = localize('login::metaDescription');
	const metaTitle = localize('login::metaTitle');
	const metadata = {
		link: [
			{
				href: 'https://www.abcmouse.com/abc/login/',
				rel: 'canonical',
			},
		],
		metaTag: [
			{
				content: metaDescription,
				name: 'description',
			},
			{
				content: metaDescription,
				property: 'og:description',
			},
			{
				content: metaTitle,
				property: 'og:title',
			},
			{
				content: 'https://www.abcmouse.com/abc/login/',
				property: 'og:url',
			},
		],
		schemaOrg: {
			graph: {
				webPage: {
					description: metaDescription,
					id: 'https://www.abcmouse.com/abc/login/#webpage',
					name: metaTitle,
					url: 'https://www.abcmouse.com/abc/login/',
				},
			},
		},
		title: metaTitle,
	};
	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			policies: { policy, policyExceptionHandler },
			routePath: '/login',
		});

		return {
			metadata: page.metadata,
			page,
		};
	}

	const resolvedMetadata = new Page({ routePath: '/login', metadata }).metadata;
	return {
		metadata: resolvedMetadata,
	};
}
